const ability = {
    state: {
        isSidebarShow: true,
        setCliQueryParam: {}
    },
    mutations: {
        SET_SIDEBAR_SHOW: (state, isShow) => {
            state.isSidebarShow = isShow;
        },
        SET_CLI_QUERY_PARAM: (state, data) => {
            state.setCliQueryParam = data
        }
    },
    actions: {
        setCliQueryParam({ commit, state }, data) {
            commit('SET_CLI_QUERY_PARAM', data)
        }
    }
};

export default ability;